// Tracks which keyed action is in flight so only the clicked button spins. Unmount-safe: the
// post-await state update is guarded, since the action may have closed the modal.

import { useCallback, useEffect, useRef, useState } from 'react';

export const useLoadingAction = () => {
  const [loadingKey, setLoadingKey] = useState<string | null>(null);
  const mounted = useRef(true);

  useEffect(
    () => () => {
      mounted.current = false;
    },
    [],
  );

  const run = useCallback(async (key: string, action: () => Promise<unknown>) => {
    setLoadingKey(key);
    try {
      await action();
    } finally {
      if (mounted.current) setLoadingKey(null);
    }
  }, []);

  return { loadingKey, run };
};
